import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import apis from "../../services";
import { DataGrid } from "@mui/x-data-grid";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import Container from "@mui/material/Container";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import AdminUsersTable from "components/datagrid/AdminUsersTable";
import UsersDocumentTable from "components/datagrid/UsersDocumentTable";
import useNavigate from "hooks/Navigate";
import { Table, Form, Row, Col } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";

export const UserDocuments = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  /*Methods*/
  const fetchAllUsers = async () => {
    setLoading(true);
    try {
      const res = await apis.getAllUser();
      if (res.data.status) setUsers(res.data.users);
    } finally {
      setLoading(false);
    }
  };

  const approvedDocuments = async (id) => {
    const res = await apis.approvedDocumentsUser(id);
    if (res.data.status) {
      await fetchAllUsers();
      toast.success(res.data.message);
    } else toast.error(res.data.message);
  };

  useEffect(() => {
    (async () => {
      await fetchAllUsers();
    })();
  }, []);

  let tables;
  if (searchQuery) {
    tables = UsersDocumentTable(filteredUsers, {
      navigate,
      approvedDocuments,
    });
  } else {
    tables = UsersDocumentTable(users, {
      navigate,
      approvedDocuments,
    });
  }

  const filterUsers = () => {
    const filtered = users?.filter((user) => {
      const fullName = `${user.name} ${user.email}`.toLowerCase();
      return fullName?.includes(searchQuery.toLowerCase());
    });
    setFilteredUsers(filtered);
  };
  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            {loading ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container
                // maxWidth="xl"
                sx={{ mt: 4, mb: 4 }}
                className="mainContainerComp"
              >
                <div className="flex-with-title"></div>
                <Col xs={12} md={12} lg={12} className="mt-3 p-0">
                  <Form.Group className="my-2" style={{ position: "relative" }}>
                    <Form.Label>Search by Name or Email</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter name or email"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onKeyUp={filterUsers}
                    />
                    <div className="searchCon">
                      <CiSearch
                        className="search-icon"
                        color="#AFAEAE"
                        fontSize={18}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Grid
                  item
                  container
                  justifyContent="flex-end"
                  className="mt-4"
                  sx={{ height: "600px", position: "relative", zIndex: "10" }}
                >
                  <DataGrid
                    //checkboxSelection
                    rows={tables?.rows}
                    columns={tables?.columns}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                  />
                  <img
                    src="/assets/images/frameCardBG.png"
                    alt="frameCardBG"
                    style={{
                      position: "absolute",
                      bottom: "-46px",
                      left: "-24px",
                      width: "296px",
                      zIndex: "-1",
                    }}
                  />
                </Grid>
              </Container>
            )}
          </Box>
        </div>
      </Box>
    </>
  );
};

export default UserDocuments;
